import type { ArtifactPreview } from "~/services/artifacts";
import { ArtifactShell } from "./ArtifactShell";
import { FileArtifactBody } from "./FileArtifactBody";

// BLOB artifacts cover non-image binaries (PDFs, archives, generic files).
// The preview service routes image-shaped blobs through `artifact_type=image`
// to ImageArtifact, so we never need to detect images here.
export const BlobArtifact = ({ preview }: { preview: ArtifactPreview }) => (
  <ArtifactShell preview={preview}>
    <FileArtifactBody preview={preview} />
  </ArtifactShell>
);
